import React from "react";
import PropTypes from "prop-types";
import { MenuButton as RMDMenuButton} from "react-md";

const MenuButton = ({children, ...otherProps}) => (
  <div className={"MenuButton-Root"}>
    <RMDMenuButton
      id="dropdown arrow"
      {...otherProps}
      position={RMDMenuButton.Positions.BELOW}
      iconChildren="arrow_drop_down"
      iconBefore={false}
      raised
    >
      {children}
    </RMDMenuButton>
  </div>
);

MenuButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default MenuButton;